module.exports = __webpack_public_path__ + "static/media/error.af38ca30.png";